import {BUSINESS_NAME} from "@/content";

export type ParallaxContent = {
    title: string;
    subTitle: string;
    overline: string;
    imageUrl: string;
    buttonCTA: string;
    tint: string;
    align: 'left' | 'right' | 'center';
    buttonLink: string;
};

export const parallaxContent1: Omit<ParallaxContent, 'buttonLink'> & { buttonLink?: string } = {
    title: 'Save More with Solar Power Sydney',
    subTitle: 'Slash your energy bills with expert solar panel installations, battery storage, and system upgrades designed for Sydney homes and businesses.',
    overline: BUSINESS_NAME,
    imageUrl: '/images/parallax/pllx-1.jpg',
    buttonCTA: 'Get a Free Solar Quote',
    align: 'left',
    tint: 'rgba(0, 0, 0, 0.3)',
    buttonLink: undefined,
}

export const parallaxContent2: Omit<ParallaxContent, 'buttonLink'> & { buttonLink?: string } = {
    title: 'Smart Solar Solutions Sydney',
    subTitle: 'Save on energy bills with professional solar panel installation, battery storage, and servicing tailored for Sydney homes and businesses.',
    overline: BUSINESS_NAME,
    imageUrl: '/images/parallax/pllx-2.jpg',
    buttonCTA: 'Get Your Free Solar Quote',
    tint: 'rgba(0, 0, 0, 0.3)',
    align: 'right',
    buttonLink: undefined, // define this in the page
}
